import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconCardMaster = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#FF5A00",
			d: "M12.4996 5.60004H7.59961V14.4H12.4996V5.60004Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EB001B",
			d: "M7.9 10C7.9 8.20002 8.7 6.60002 10 5.60002C9.1 4.90002 7.9 4.40002 6.6 4.40002C3.5 4.40002 1 6.90002 1 10C1 13.1 3.5 15.6 6.6 15.6C7.9 15.6 9.1 15.2 10 14.4C8.7 13.4 7.9 11.8 7.9 10Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F79E1B",
			d: "M19 10C19 13.1 16.5 15.6 13.4 15.6C12.1 15.6 10.9 15.2 10 14.4C11.3 13.4 12.1 11.8 12.1 10C12.1 8.20002 11.3 6.60002 10 5.60002C10.9 4.90002 12.1 4.40002 13.4 4.40002C16.5 4.40002 19 6.90002 19 10Z"
		})
	]
});
const ForwardRef = forwardRef(SvgIconCardMaster);
export default ForwardRef;
